import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebaseConfig';
import { useUserProfile } from './UserProfileContext';

const PendingLeavesContext = createContext({
  pendingLeaveCount: 0,
  pendingLeaves: [],
  refreshPendingLeaves: () => {},
});

// Bekleyen izin taleplerini görebilecek yetki rolleri
const LEAVE_MANAGER_ROLES = [
  'admin',
  'Kısıtlı Admin',
  'İnsan Kaynakları',
  'Proje Yöneticisi',
  'Finans Yöneticisi',
];

export const PendingLeavesProvider = ({ children }) => {
  const { userAuthorization } = useUserProfile();
  const [pendingLeaves, setPendingLeaves] = useState([]);

  const canManageLeaves = Array.isArray(userAuthorization) &&
    userAuthorization.some((role) => LEAVE_MANAGER_ROLES.includes(role));

  const refreshPendingLeaves = useCallback(async () => {
    if (!canManageLeaves) {
      setPendingLeaves([]);
      return;
    }
    try {
      const q = query(
        collection(db, 'LeaveRequests'),
        where('status', '==', 'PENDING')
      );
      const snapshot = await getDocs(q);
      const requests = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setPendingLeaves(requests);
    } catch (error) {
      console.error('Error fetching pending leave requests:', error);
    }
  }, [canManageLeaves]);

  // İlk yüklemede ve her 60 saniyede bir bekleyen izinleri çek
  useEffect(() => {
    refreshPendingLeaves();
    const interval = setInterval(refreshPendingLeaves, 60000);
    return () => clearInterval(interval);
  }, [refreshPendingLeaves]);

  return (
    <PendingLeavesContext.Provider
      value={{
        pendingLeaveCount: pendingLeaves.length,
        pendingLeaves,
        refreshPendingLeaves,
      }}
    >
      {children}
    </PendingLeavesContext.Provider>
  );
};

export const usePendingLeaves = () => useContext(PendingLeavesContext);

export default PendingLeavesContext;
